import React, { PropsWithChildren, useEffect, useState } from "react";
import { useAuth } from "./use-auth";

interface CheckKeycloakProps {}

export const CheckKeycloakInstance: React.FC<PropsWithChildren<CheckKeycloakProps>> = ({
  children
}) => {
  const { initialized } = useAuth();
  const [show, setShow] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 2000);
    return () => setShow(false);
  }, [setShow]);

  return initialized ? (
    <>{children}</>
  ) : (
    <div>
      {show ? (
        <>
          <p>Loading...</p>
        </>
      ) : (
        <> </>
      )}
    </div>
  );
};
